import { useEffect, useMemo, useState } from 'react';
import { apiGet } from '../../../../utils/apiClient';
import { resolveSubdomain } from '../data/useStorefrontData';

export default function useWebsitePackage({ storeSlug }) {
  const [state, setState] = useState({ loading: true, website: null, error: '' });
  const subdomain = useMemo(resolveSubdomain, []);
  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams(window.location.search);
    const draft = params.get('website_draft');
    const load = async () => {
      if (!storeSlug) { setState({ loading:false, website:null, error:'' }); return; }
      try {
        const response = draft
          ? await apiGet(`/api/website-packages/${encodeURIComponent(draft)}?store_id=${encodeURIComponent(params.get('website_store') || '')}`)
          : await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/website-packages/public/${encodeURIComponent(subdomain)}?store_slug=${encodeURIComponent(storeSlug)}`, { cache: 'no-store' });
        if (!response.ok) throw new Error('Could not load the website design. Please reload.');
        const result = await response.json();
        if (!cancelled) setState({ loading:false, website:draft ? result.draft : result.website, error:'' });
      } catch (e) { if (!cancelled) setState({ loading:false, website:null, error:e.message }); }
    };
    load();
    return () => { cancelled = true; };
  }, [storeSlug, subdomain]);
  const draftId = new URLSearchParams(window.location.search).get('website_draft');
  const loadedDraftId = state.website?.id;
  const loadedStoreId = state.website?.store_id;
  useEffect(() => {
    if (!draftId || loadedDraftId !== draftId) return undefined;
    const receive = (event) => {
      const message = event.data;
      if (event.origin !== window.location.origin || event.source !== window.parent || message?.type !== 'PLATEOS_WEBSITE_PREVIEW_EDITS' || message.draftId !== draftId || message.storeId !== loadedStoreId) return;
      const edits = message.edits;
      if (!edits || !['settings','sections','products','collections'].every((key) => edits[key] && typeof edits[key] === 'object' && !Array.isArray(edits[key]))) return;
      setState((prev) => ({...prev,website:{...prev.website,edits,canvas:message.canvas}}));
    };
    window.addEventListener('message',receive);
    window.parent?.postMessage({type:'PLATEOS_WEBSITE_PREVIEW_READY',draftId},window.location.origin);
    return () => window.removeEventListener('message',receive);
  }, [draftId, loadedDraftId, loadedStoreId]);
  return state;
}
